module.exports = __webpack_public_path__ + "static/media/MapArea.7351772b.svg";